require( './bootstrap' );

import LazyLoad from "vanilla-lazyload";


(function ($) {
	"use strict";

	$( document ).ready(
		function () {

			var btn = document.getElementById( 'loadmore' );

			if (btn) {
				loadMore();
			}

			function loadMore() {
				var btn_text = btn.textContent;

				btn.addEventListener(
					'click',
					function () {
						btn.disabled    = true;
						btn.textContent = 'Load...';
						var request     = new XMLHttpRequest();
						request.open( 'POST', ajax.url + '?action=loadmore&query=' + true_posts + '&page=' + current_page, true );
						request.send();
						request.onload  = function () {
							if (request.status >= 200 && request.status < 400) {
								var resp = request.responseText;
								if (resp && resp !== '0') {
									var div       = document.createElement( "div" );
									div.innerHTML = resp;
									while (div.firstChild) {
										var item = div.removeChild( div.firstChild );
										btn.parentNode.parentNode.insertBefore( item, btn.parentNode );
									}
									if (current_page == (max_pages)) {
										btn.parentNode.style.display = 'none';
									}
									current_page++;
									btn.textContent = btn_text;
									btn.disabled    = false;
								} else {
									btn.parentNode.style.display = 'none';
									console.log( 'No response...' );
								}

							} else {
								console.log( 'Error...' );
							}
						};
						request.onerror = function () {
							console.log( 'Connection Error...' );
						};
					}
				);
			}

		}
	);

})( jQuery );
document.addEventListener( "DOMContentLoaded", event => {


	if ('disable' !== getCookie('modal')) {
		getUserConutry();
	}


	function getUserConutry() {
		var ajaxdata = {
			action: 'my_action',
			nonce_code: ajax.nonce
		};
		$.post(ajax.url, ajaxdata, function (response) {
			if (true === response.showModal) {
				lang_modal()
			}
		});
	}



	/* lang switcher modal */
	function lang_modal() {
		let modal = document.getElementById("modal-lang");
		let closeModal = document.querySelector(".close-modal");
		let langBtnModal = Array.from(document.querySelectorAll(".modal__language a"));

		// check if modal exist
		if (modal) {
			if (!checkBot()) {
				modal.classList.remove('hide');

				// check all langs button
				for (let i = 0; i < langBtnModal.length; i++) {
					langBtnModal[i].onclick = function () {
						addCookie();
					}
				}
				// click on X
				if (closeModal) {
					closeModal.onclick = function () {
						addCookie();
						modal.remove();
					}
				}

				// click around modal window
				window.onclick = function (event) {
					if (event.target == modal) {
						addCookie();
					}
					modal.remove();
				}

				// cookie rules
				function addCookie() {
					modal.classList.add('hide');
					document.cookie = "modal=disable; path=/";
				}
			}
		}
	}

	function checkBot() {
		const UA = navigator.userAgent.toLowerCase();
		const myBots = ['rambler', 'googlebot', 'aport', 'yahoo', 'msnbot', 'turtle', 'mail.ru', 'omsktele', 'Google-', 'google',
			'yetibot', 'picsearch', 'sape.bot', 'sape_context', 'gigabot', 'snapbot', 'alexa.com',
			'megadownload.net', 'askpeter.info', 'igde.ru', 'ask.com', 'qwartabot', 'yanga.co.uk',
			'scoutjet', 'similarpages', 'oozbot', 'shrinktheweb.com', 'aboutusbot', 'followsite.com',
			'dataparksearch', 'google-sitemaps', 'appEngine-google', 'feedfetcher-google',
			'liveinternet.ru', 'xml-sitemaps.com', 'agama', 'metadatalabs.com', 'h1.hrn.ru',
			'googlealert.com', 'seo-rus.com', 'yaDirectBot', 'yandeG', 'yandex',
			'yandexSomething', 'Copyscape.com', 'AdsBot-Google', 'domaintools.com',
			'Nigma.ru', 'bing.com', 'dotnetdotcom', 'custom-table-of-content'];
		return myBots.some(bot => UA.includes(bot));
	}

});

function getCookie(name) {
	const value = `; ${document.cookie}`;
	const parts = value.split(`; ${name}=`);
	if (parts.length === 2) return parts.pop().split(';').shift();
}

// -----------------------------------------------------------------------------------------------//

document.addEventListener( "DOMContentLoaded", readyHTML );

function readyHTML() {
	// adapt('990',['#menu-footer-menu'],'cover','.insert_adapt_menu');
	adapt( '990', ['#menu-header-menu'], 'cover', '.insert_adapt_menu' );
}


function move_block(adaptWid, block_to_move, place_to_move) {
	window.addEventListener( 'resize', _move_resizewindow );
	var place_to = document.querySelector( place_to_move );
	var block_to = document.querySelector( block_to_move );
	if (block_to && place_to) {
		var block = block_to.querySelector( 'ul' );
		var place = place_to.querySelector( 'ul' );
		if (block) {
			block.classList.add( 'block_to_move' );
		}
		if (place) {
			place.classList.add( 'place_to_move' );
		}
	}
	var wid = window.innerWidth;
	_move_resizewindow();

	function _move_resizewindow() {
		wid = window.innerWidth;
		var activeItems;
		if (wid < adaptWid) {
			var activeLiBlock = block.querySelectorAll( 'li' );
			var activeLiPlace = place.querySelectorAll( 'li' );
			if (activeLiBlock) {

			}
			if (block && place) {
				place_to.insertBefore( block, place );
			}
		} else {
			if (block && place) {
				var block_replaced = place_to.querySelector( '.block_to_move' );
				if (block_replaced) {
					block_to.appendChild( block_replaced );
				}
			}
		}
	}
}

function scrollfunc() {

}

function adapt(adaptWid, menu, covertable, insert_adapt_menu) {
	window.addEventListener( 'resize', _resizewindow );
	window.addEventListener( 'scroll', scrollfunc );
	if (covertable && covertable != 'nocover') {
		_coverTable();
	}
	var body = document.querySelector( 'body' );

	function _coverTable() {
		var table = document.querySelectorAll( 'table' );
		for (var i = table.length - 1; i >= 0; i--) {
			var cover = document.createElement( 'div' );
			cover.classList.add( 'cover-table' );
			table[i].parentNode.insertBefore( cover, table[i] );
			cover.appendChild( table[i] );
		}
	}

	var adapt_menu = [];
	if (menu) {
		for (var l = 0; l < menu.length; l++) {
			adapt_menu[l] = document.querySelectorAll( menu[l] );
		}
	}

	var adapt_menu_cover = document.createElement( 'div' );
	adapt_menu_cover.classList.add( 'cover-menu' );
	body.appendChild( adapt_menu_cover );

	var adapt_menu_cover = document.createElement( 'div' );
	adapt_menu_cover.classList.add( 'cover-menu' );
	// document.querySelector('.adapt-menu-wrp').appendChild(adapt_menu_cover);
	// body.appendChild(adapt_menu_cover);
	document.querySelector( '.adapt-menu-wrp' ).appendChild( adapt_menu_cover );
	var gamburger = document.querySelector( '.adapt-menu-icon' );
	if ( ! gamburger) {
		var gamburger = document.createElement( 'div' );
		gamburger.classList.add( 'adapt-menu-icon' );
		gamburger.innerHTML = '<span class="line-white-menu"></span>\n<span class="line-white-menu"></span>\n<span class="line-white-menu"></span>\n';
	}
	var gamburger2 = document.querySelector( '.show-menu-icon' );
	if ( ! gamburger2) {
		// var gamburger2 = document.createElement('div');
		// gamburger2.classList.add('show-menu-icon');
	}
	var bgicon = document.querySelector( '.icon-menu-bg' );
	if ( ! bgicon) {
		var bgicon = document.createElement( 'div' );
		bgicon.classList.add( 'icon-menu-bg' );
	}
	var closemenu = document.querySelector( '.menu-close-button' );
	if ( ! closemenu) {
		var closemenu       = document.createElement( 'div' );
		closemenu.innerHTML = '<span class="line-white-menu"></span>\n<span class="line-white-menu"></span>\n<span class="line-white-menu"></span>\n';
		closemenu.classList.add( 'menu-close-button' );
	}

	var menu_menu = document.querySelector( insert_adapt_menu );
	if (gamburger && adapt_menu) {
		if (menu_menu) {
			menu_menu.appendChild( gamburger );
		} else {
			// body.appendChild(gamburger);
		}

		gamburger.addEventListener( 'click', showmenu );
	}
	if (gamburger2 && adapt_menu) {
		body.appendChild( gamburger2 );
		gamburger2.addEventListener( 'click', showmenu );
	}
	if (bgicon && adapt_menu) {
		body.appendChild( bgicon );
		bgicon.addEventListener( 'click', hidemenu );
	}
	if (closemenu && adapt_menu_cover) {
		adapt_menu_cover.appendChild( closemenu );
		closemenu.addEventListener( 'click', hidemenu );
	}
	if (adapt_menu_cover && adapt_menu) {
		for (var d = 0; d < adapt_menu.length; d++) {
			for (var f = 0; f < adapt_menu[d].length; f++) {
				adapt_menu_cover.appendChild( adapt_menu[d][f].cloneNode( true ) );
			}
		}
	}
	var elements = adapt_menu_cover.querySelectorAll( '*' );
	for (var e = 0; e < elements.length; e++) {
		elements[e].removeAttribute( 'id' );
	}

	var menusss = document.querySelectorAll( ".cover-menu .menu-item-has-children" );
	for (var i = 0; i < menusss.length; i++) {
		var spanMenuTrigger = document.createElement( 'span' );
		spanMenuTrigger.setAttribute( 'class', 'note' );

		// appendChild(spanMenuTrigger)
		menusss[i].appendChild( spanMenuTrigger );
		// console.log(menusss[i]);
	}

	/* проверка на вложенность и открытие по нажатию */
	var acc = document.querySelectorAll( ".cover-menu .menu-item-has-children span" );
	for (var i = 0; i < acc.length; i++) {
		acc[i].addEventListener(
			"click",
			function () {
				event.stopPropagation();
				if (this.parentElement.classList.contains( 'active' )) {
					this.parentElement.classList.remove( 'active' );
				} else {
					this.parentElement.classList.add( "active" );
				}
			}
		);
	}

	_resizewindow();

	function _resizewindow() {
		var wid = window.innerWidth;
		if (wid < adaptWid) {
			if (gamburger) {
				gamburger.addEventListener( 'click', showmenu );
			}
			if (gamburger2) {
				gamburger2.addEventListener( 'click', showmenu );
			}
			if (bgicon) {
				bgicon.addEventListener( 'click', showmenu );
			}
			if (closemenu) {
				closemenu.addEventListener( 'click', hidemenu );
			}
		} else {
			if (gamburger) {
				gamburger.removeEventListener( 'click', showmenu );
				gamburger.classList.remove( 'activeGamburger' );
			}
			if (gamburger2) {
				gamburger2.removeEventListener( 'click', showmenu );
			}
			if (adapt_menu_cover) {
				adapt_menu_cover.classList.remove( 'showmenu' );
			}
			if (closemenu) {
				closemenu.removeEventListener( 'click', hidemenu );
			}
			if (bgicon) {
				bgicon.classList.remove( 'showbg' );
				bgicon.removeEventListener( 'click', showmenu );
			}
			if (body) {
				body.classList.remove( 'OverflowHiden' );
			}
		}
	}

	function showmenu() {
		if (gamburger) {
			gamburger.removeEventListener( 'click', showmenu );
			gamburger.classList.add( 'activeGamburger' );
			gamburger.addEventListener( 'click', hidemenu );
		}
		if (gamburger2) {
			gamburger2.removeEventListener( 'click', showmenu );
			gamburger2.addEventListener( 'click', hidemenu );
		}
		var scrolled = window.pageYOffset || document.documentElement.scrollTop;

		if (adapt_menu_cover) {
			adapt_menu_cover.classList.add( 'showmenu' );
		}
		if (closemenu) {
			closemenu.addEventListener( 'click', hidemenu );
		}
		if (bgicon) {
			bgicon.classList.add( 'showbg' );
			bgicon.addEventListener( 'click', showmenu );
		}
		if (body) {
			body.classList.add( 'OverflowHiden' );
		}
	}

	function hidemenu() {
		if (gamburger) {
			gamburger.addEventListener( 'click', showmenu );
			gamburger.classList.remove( 'activeGamburger' );
			gamburger.removeEventListener( 'click', hidemenu );
		}
		if (gamburger2) {
			gamburger2.addEventListener( 'click', showmenu );
			gamburger2.removeEventListener( 'click', hidemenu );
		}
		if (bgicon) {
			bgicon.classList.remove( 'showbg' );
			bgicon.removeEventListener( 'click', showmenu );
		}
		if (closemenu) {
			closemenu.removeEventListener( 'click', hidemenu );
		}
		if (adapt_menu_cover) {
			adapt_menu_cover.classList.remove( 'showmenu' );
		}
		if (body) {
			body.classList.remove( 'OverflowHiden' );
		}
	}
}


// ----------------- Adaptive menu End --------------------//


// ----------------- FAQ Begin --------------------//
(function ($) {
	'use strict';
	$( document ).ready(
		function () {
			$( '.accordion-wrapper__item .title' ).on(
				'click',
				function () {
					$( '.accordion-content' ).slideUp();

					if ($( this ).hasClass( 'open' )) {
						$( '.accordion-wrapper__item .title' ).removeClass( 'open' )
						$( this ).next().slideUp();
						return false;
					} else {
						$( '.accordion-wrapper__item .title' ).removeClass( 'open' );
						$( this ).addClass( 'open' );
						$( this ).next().slideDown();
					}
					return false;
				}
			);
		}
	);

})( jQuery );

document.addEventListener(
	'DOMContentLoaded',
	function () {
		let myLazyLoad = new LazyLoad( {
			elements_selector: ".lazy-load"
		} );
	}
);

/**
 * Loadmore from loadmore.min.js
 */
(function ($) {
	$('#true_loadmore').click(function(){
		$(this).text('Загрузка...'); // изменяем текст кнопки, вы также можете добавить прелоадер
		var data = {
			'action': 'loadmore',
			'query': true_posts,
			'page' : current_page
		};
		$.ajax({
			url:ajaxurl, // обработчик
			data:data, // данные
			type:'POST', // тип запроса
			success:function(data){
				if( data ) {
					$('#true_loadmore').text('Загрузить еще'); // вставляем новые посты
					$('.obj_row').before(data); // вставляем новые посты
					current_page++; // увеличиваем номер страницы на единицу
					if (current_page == max_pages) $("#true_loadmore").remove(); // если последняя страница, удаляем кнопку
				} else {
					$('#true_loadmore').remove(); // если мы дошли до последней страницы постов, скроем кнопку
				}
			},
			/*ЕСЛИ ЕСТЬ load more для картинок*/
			complete: function () {
				let myLazyLoad = new LazyLoad({
					elements_selector: ".lazy-load"
				});
			}
		});
	});
})(jQuery);